import { CircularProgress, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { createPortal } from "react-dom";
import DatePicker from "react-datepicker";
import CalendarIcon from "../../../../../../common/components/datePicker/CalendarIcon";
import StyledDatePickerWrapper from "../../../../../../common/components/datePicker/StyledDatePicker";

type LiveViewTimelapseControlsProps = {
  selectedDate: Date | null;
  minDate: Date;
  maxDate: Date;
  isDownloadDisabled: boolean;
  downloading: boolean;
  isDateSelectable: (date: Date) => boolean;
  onDateChange: (date: Date | null) => void;
  onDownload: () => void | Promise<void>;
};

const LiveViewTimelapseControls = ({
  selectedDate,
  minDate,
  maxDate,
  isDownloadDisabled,
  downloading,
  isDateSelectable,
  onDateChange,
  onDownload,
}: LiveViewTimelapseControlsProps): JSX.Element => (
  <Box
    sx={{
      padding: 2,
    }}
  >
    <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
      Timelapse date
    </Typography>

    <Typography
      variant="body2"
      color="text.secondary"
      sx={{ mb: 1, fontSize: "14px" }}
    >
      A time period of one day is available for downloading.
    </Typography>

    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} md={8}>
        <StyledDatePickerWrapper>
          <DatePicker
            selected={selectedDate}
            onChange={onDateChange}
            icon={<CalendarIcon />}
            showIcon
            maxDate={maxDate}
            minDate={minDate}
            placeholderText="Choose Date"
            dateFormat="MM/dd/yyyy"
            isClearable
            onChangeRaw={event => {
              event.preventDefault();
            }}
            dropdownMode="select"
            popperPlacement="bottom-start"
            popperContainer={({ children }) =>
              typeof document !== "undefined"
                ? createPortal(children, document.body)
                : children
            }
            filterDate={isDateSelectable}
          />
        </StyledDatePickerWrapper>
      </Grid>

      <Grid item xs={12} md={4}>
        <Button
          sx={{
            height: "40px",
            borderRadius: "8px",
            padding: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
          variant="contained"
          fullWidth
          disabled={isDownloadDisabled}
          onClick={onDownload}
        >
          {downloading ? "Downloading..." : "Download video"}

          {downloading && <CircularProgress color="inherit" size={20} />}
        </Button>
      </Grid>
    </Grid>
  </Box>
);

export default LiveViewTimelapseControls;
